import React from 'react';

import { Link } from 'react-router-dom';

import { get } from 'lodash';

export const UrlParamLinkButton = ({ record, children, resourceType, action, fields, values, style }) => {
  let url = `/${resourceType}/${action}?`;

  const fieldsArray = fields.split(',').map((item) => item.trim());
  const valuesArray = values.split(',').map((item) => item.trim());

  fieldsArray.forEach((field, i) => {
    url += `${field}=${get(record, valuesArray[i])}&`;
  });

  url = url.slice(0, -1);

  const styles = {
    ...style,
  };

  return (
    <Link style={styles} to={url}>
      {children}
    </Link>
  );
};

export default UrlParamLinkButton;
